import bugsnag from '@bugsnag/js';
import bugsnagVue from '@bugsnag/plugin-vue';
import isError from 'lodash/isError';

/**
 * Enables javascript error tracking via Bugsnag
 * @param Vue
 */
export function enableBugsnagTracking(Vue) {
    if(process.env.MIX_APP_ENV !== 'production') {
        return;
    }
    if(window.bugsnagClient) {
        window.bugsnagClient.notify(new Error('Bugsnag Client Initialized more than once'));
        return;
    }
    window.bugsnagClient = bugsnag({
        apiKey: 'bed1152cd318debb7ad203777f74d581',
        user: { id: window.user_id }
    });
    window.bugsnagClient.use(bugsnagVue, Vue);
}

export function logError(error, data = {}) {
    if(window.bugsnagClient) {
        let err = isError(error) ? error : new Error(error);
        let options = {};
        if(Object.keys(data) > 0) {
            options['metaData'] = data;
        }
        window.bugsnagClient.notify(err, options);
    }
}
